/* esm.sh - applesauce-relay@5.2.0/dist/operators/only-events */
import{filter as e}from"rxjs";function o(){return r=>r.pipe(e(t=>t!=="EOSE"))}export{o as onlyEvents};
//# sourceMappingURL=only-events.mjs.map